import script from "./DatabaseMetaManagementView.vue?vue&type=script&setup=true&lang=js"
export * from "./DatabaseMetaManagementView.vue?vue&type=script&setup=true&lang=js"

import "./DatabaseMetaManagementView.vue?vue&type=style&index=0&id=53eb78fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53eb78fa"]])

export default __exports__